module.exports = __webpack_public_path__ + "static/media/full_12.00ce4d11.jpg";